(function (factory) {
    typeof define === 'function' && define.amd ? define(factory) :
    factory();
}(function () { 'use strict';

    function initLegalDocs($) {
        $(document).on('elementor/popup/show', () => {
            console.log('elementor/popup/show');
            init();
        });

        init();
    }

    function init() {
        const regionSelect = document.querySelector('#form-field-region');
        const legalNotes = document.querySelector('#legal-notes');

        if (!legalNotes || !regionSelect) {
            return;
        }

        showLegalNotes(regionSelect.value);
        regionSelect.addEventListener('change', (e) => showLegalNotes());

        function showLegalNotes() {
            const region = detectRegionDoc();

            const url = '/legal-docs-' + region + '?iframe=true';

            const frame = document.createElement('iframe');
            frame.innerHTML = 'loading...';
            frame.src = url;
            legalNotes.innerHTML = '';
            legalNotes.append(frame);
        }

        function detectRegionDoc() {
            let region = regionSelect.value;

            if (region === 'canada') {
                region = 'usa';
            } else if (region === 'china') {
                region = 'europe';
            } else if (region === 'other') {
                region = 'europe';
            }

            return region;
        }
    }

    /*
     * Custom
     */

    (function ($) {

        /**
         * Init
         */

        try {
            initLegalDocs($);
        } catch (err) {
            console.error(err);
        }

        // GLobal API.
        window.initLegalDocs = initLegalDocs;

    })(window.jQuery);

}));
